module.exports = __webpack_public_path__ + "static/media/44.fde0e14a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/ad/2/44.png
// module id = 125
// module chunks = 0